// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // SingleTaskWatcherConnectedProps,
  SingleTaskWatcherMapStateReturnType,
} from './types'

export const SingleTaskWatcherMapState = (): // state: StateReducers,
// props: SingleTaskWatcherConnectedProps,
SingleTaskWatcherMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
